import React from "react";
import {CityAnaliticsPage} from "./CityAnaliticsPage";

export const HomePage: React.FC = () => {
    return <CityAnaliticsPage/>;
};
